@if (establishmentId()) {
    <router-outlet />
} @else {
    <app-establishment-empty-state />
}
